// mds-dojo — dojox/widget/MonthAndYearlyCalendar — FAITHFUL port of
// references/dojox/widget/MonthAndYearlyCalendar.js.
//
// _CalendarBase composed with only the month/year view mixin. A genuinely thin
// wrapper in the real source too; the weight lives in _CalendarBase + the view chain,
// which is stubbed here (see _CalendarBase.ts for the TODO on porting the full
// closure). Not referenced by the oracle app/suite.
//
// PORT NOTES: AMD define(...) → ESM imports; classic declare() kept via the faithful
// declare-runtime.

import declare from '../../dojo/_base/declare-runtime';
import _CalendarBase from './_CalendarBase';
import _CalendarMonthYear from './_CalendarMonthYear';

export default declare('dojox.widget.MonthAndYearlyCalendar', [_CalendarBase, _CalendarMonthYear], {
  // summary:
  //		A calendar with only a month/year view.
});
